module.exports = __webpack_public_path__ + "img/background.6e656081.png";